import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalHeader,
    Text,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import { useTranslation } from "react-i18next";
import { isWaitList } from "utils/booking";
interface ICancelModal {
    isOpen: boolean;
    handleCancelModalModalClose: () => void;
    handleCancelModalCancel: () => void;
}

const CancelModal = ({
    isOpen,
    handleCancelModalModalClose,
    handleCancelModalCancel,
}: ICancelModal) => {
    const { t } = useTranslation();
    const { data: booking } = useWebBooking();

    if (!booking) return null;

    const isWaitListBooking = isWaitList(booking);
    const isInquiry = booking.anyNonCompleteInquirySubStatus();

    const getCancelModalTexts = () => {
        if (isWaitListBooking) {
            return {
                title: t("waitList.waitListBookingCancel"),
                body: t("waitList.waitListAreYouSureCancel"),
                button: t("waitList.waitListBookingCancel"),
            };
        }

        if (isInquiry) {
            return {
                title: t("bookingRequest.cancelModal.title"),
                body: t("bookingRequest.cancelModal.body"),
                button: t("bookingRequest.cancelModal.button"),
            };
        }

        return {
            title: t("confirmBookingCancel"),
            body: t("areYouSureCancel"),
            button: t("confirmBookingCancel"),
        };
    };
    const { title, body, button } = getCancelModalTexts();
    return (
        <Modal isOpen={isOpen} onClose={handleCancelModalModalClose} size="md">
            <ModalHeader
                display="flex"
                justifyContent="space-between"
                p={ThemeSpaceVariable.Medium}
            >
                <Text fontWeight="medium" fontSize={ThemeFontSizeVariable.XLarge}>
                    {title}
                </Text>
                <ModalCloseButton />
            </ModalHeader>
            <ModalBody display="flex" flexDirection="column" p={ThemeSpaceVariable.Medium}>
                <Text
                    fontSize={ThemeFontSizeVariable.Large}
                    mt={ThemeSpaceVariable.XSmall}
                    mb={ThemeSpaceVariable.Large}
                    fontWeight="500"
                >
                    {body}
                </Text>

                <Button
                    variant="primary"
                    size="md"
                    alignSelf="flex-end"
                    onClick={handleCancelModalCancel}
                >
                    {button}
                </Button>
            </ModalBody>
        </Modal>
    );
};

export default CancelModal;
